import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CallRoutingModule } from './call-routing.module';

@NgModule({
  declarations: [],
  imports: [CommonModule, CallRoutingModule, SharedModule],
})
export class CallModule {}
